import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';

import analytics from '../lib/analytics';
import resourcesContent from '../lib/libraries/resources/index.js';
import resourceTags from '../lib/libraries/resource-tags.js';
import tagMessages from '../lib/libraries/tag-messages.js';
import LibraryComponent from '../components/library/library.jsx';

import {connect} from 'react-redux';
import {closeResourcesLibrary, openLoadingProject, closeLoadingProject} from '../reducers/modals';

import {setProjectTitle} from '../reducers/project-title';

const messages = defineMessages({
    resourcesLibraryTitle: {
        defaultMessage: 'Levelwise Learning resources',
        description: 'Heading for the resources page',
        id: 'gui.resourcesLibrary.resources'
    },
    loadError: {
        id: 'gui.resourcesLibrary.loadError',
        defaultMessage: 'The resource file failed to load.',
        description: 'Error shown when a resource file cannot be loaded.'
    }
});

class ResourcesLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    handleItemSelect (item) {
        analytics.event({
            category: 'library',
            action: 'Select Resource',
            label: item.id
        });

        if (item.sourcePath) {
            // Close the resources library modal and show the loader
            this.props.onRequestClose();
            this.props.onOpenLoadingProject();

            // Fetch the .sb3 file and load it into the VM
            fetch(item.sourcePath)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch ${item.sourcePath}`);
                    }
                    return response.arrayBuffer();
                })
                .then(arrayBuffer => this.props.vm.loadProject(arrayBuffer).then(() => {
                    const title = item.name.props ? this.props.intl.formatMessage(item.name.props) : item.name;
                    if (title) {
                        this.props.onSetProjectTitle(title);
                    }
                }))
                .then(() => {
                    this.props.onCloseLoadingProject();
                })
                .catch(error => {
                    console.error('Error loading resource file:', error);
                    this.props.onCloseLoadingProject();
                    alert(this.props.intl.formatMessage(messages.loadError)); // eslint-disable-line no-alert
                });
        }
    }

    render () {
        if (!this.props.visible) return null;
        return (
            <LibraryComponent
                data={resourcesContent}
                filterable
                id="resourcesLibrary"
                tags={resourceTags}
                title={this.props.intl.formatMessage(messages.resourcesLibraryTitle)}
                visible={this.props.visible}
                withCategories
                messages={tagMessages}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

ResourcesLibrary.propTypes = {
    intl: intlShape.isRequired,
    onCloseLoadingProject: PropTypes.func,
    onOpenLoadingProject: PropTypes.func,
    onRequestClose: PropTypes.func,
    onSetProjectTitle: PropTypes.func,
    visible: PropTypes.bool,
    vm: PropTypes.shape({
        loadProject: PropTypes.func
    })
};

const mapStateToProps = state => ({
    visible: state.scratchGui.modals.resourcesLibrary,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeResourcesLibrary()),
    onSetProjectTitle: title => dispatch(setProjectTitle(title)),
    onOpenLoadingProject: () => dispatch(openLoadingProject()),
    onCloseLoadingProject: () => dispatch(closeLoadingProject())
});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(ResourcesLibrary));
